/**
 * Moza bundle builder — cosmetic label swap + auto-scroll suppression.
 *
 * The Easy Bundles app renders its final CTA button as "Add To Cart"
 * (text set by their own JS, not by us). This just normalizes the
 * casing to "Add to Cart" wherever that label appears — it does NOT
 * touch the button's click handler, cart logic, or the app's own JS in
 * any way. The "Next" label shown on earlier steps is left untouched.
 *
 * Also suppresses the app's own auto-scroll-on-step-change animation.
 * Traced live via a patched scrollTop setter: every time you switch a
 * category tab (or step), easy-bundle-full-page-min.js runs its own
 * manual scroll-easing loop (~70 scrollTop writes over ~250ms) to
 * reposition the page — this is what read as the page "bugging out".
 * We block ONLY scrollTop writes whose call stack originates from that
 * specific app file (checked via stack trace), so normal scrolling
 * (user-initiated, browser-native, any other script) is untouched.
 */
(function () {
  'use strict';

  var AUTOSCROLL_SOURCE = 'easy-bundle-full-page-min.js';

  function suppressAppAutoScroll() {
    var proto = Element.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'scrollTop');
    if (!desc || !desc.set || !desc.get) return; // unsupported browser; do nothing

    Object.defineProperty(proto, 'scrollTop', {
      configurable: true,
      get: desc.get,
      set: function (value) {
        var stack;
        try {
          stack = new Error().stack || '';
        } catch (e) {
          stack = '';
        }
        if (stack.indexOf(AUTOSCROLL_SOURCE) !== -1) {
          return; // this specific script's own scroll animation — skip it
        }
        return desc.set.call(this, value);
      },
    });
  }

  function relabel() {
    document.querySelectorAll('#gbbBundle .gbbFooterNextButton').forEach(function (btn) {
      if (btn.children.length === 0 && btn.textContent.trim() === 'Add To Cart') {
        btn.textContent = 'Add to Cart';
      }
    });
  }

  function init() {
    var root = document.getElementById('gbbBundle');
    if (!root) {
      // The app mounts #gbbBundle asynchronously; keep checking briefly.
      var tries = 0;
      var poll = setInterval(function () {
        tries += 1;
        var found = document.getElementById('gbbBundle');
        if (found || tries > 100) {
          clearInterval(poll);
          if (found) init();
        }
      }, 100);
      return;
    }

    relabel();
    new MutationObserver(relabel).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // Patch the prototype immediately (doesn't need the DOM ready, and needs
  // to be in place before the app's own script ever runs its scroll loop).
  suppressAppAutoScroll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
